import { createContext, useContext } from 'react';
import type { DurationUnit } from '@forecastify/shared';

/**
 * The reader's duration unit, as a context of its own so `i18n/` can read it without importing
 * `duration.tsx`, which imports `i18n/` (`decisions.md` DU-1).
 */
export interface DurationState {
  readonly unit: DurationUnit;
  readonly setUnit: (unit: DurationUnit) => void;
}

export const DurationContext = createContext<DurationState | undefined>(undefined);

/** The unit alone, or hours outside a provider — what `I18nProvider` reads. */
export function useDurationUnit(): DurationUnit {
  return useContext(DurationContext)?.unit ?? 'hours';
}
